import Alpine from 'alpinejs'

export default (function () {
  Alpine.data('slider', function (conf = {}) {
    /** @type {import('swiper').Swiper | null} */
    let instance = null
    return {
      enabled: null,
      activeIndex: 0,
      isActive(index) {
        return this.activeIndex === index
      },
      async load(loadImages = false) {
        const root = this.$root
        const slider = this.$refs['slider'] || root
        const [Swiper, modules] = await Promise.all([
          import(/* webpackMode: "lazy-once" */'swiper').then((mod) => mod.default),
          import(/* webpackMode: "lazy-once" */'swiper/modules').then((mod) => [
            mod.Navigation,
            mod.EffectCards,
            mod.FreeMode,
            mod.Autoplay,
            mod.Grid,
          ]),
          import(/* webpackMode: "lazy-once" */'swiper/css'),
          import(/* webpackMode: "lazy-once" */'swiper/css/grid'),
        ])
        const [next, prev] = [
          this.$refs['next'],
          this.$refs['prev']
        ]

        instance = new Swiper(slider, {
          modules,
          ...conf,
          ...((next || prev) && {
            navigation: {
              nextEl: next,
              prevEl: prev,
              disabledClass: 'opacity-50',
              ...conf.navigation,
            },
          }),
          on: {
            afterInit: (instance) => {
              this.enabled = instance.enabled
            },
            enable: () => {
              this.enabled = true
            },
            disable: () => {
              this.enabled = false
            },
            slidesUpdated: () => {
              // FIX
              if (!this.enabled && slider?.querySelector('.swiper-wrapper')?.hasAttribute('style')) slider.querySelector('.swiper-wrapper').removeAttribute('style')
            },
            slideChange: (instance) => {
              this.activeIndex = instance.activeIndex
            }
          },
        })

        if (loadImages) {
          slider.querySelectorAll('img').forEach(img => {
            img.loading = 'eager'
          })
        }
      },
      destroy() {
        if (instance) instance.destroy(true, true)
      },
    }
  })
})()
